<template>
    <div class="aside">
        <div v-if="contact" class="contact-info">
            <div v-if="isMultiplePolicy()" class="contact-info__header">Current Policies</div>
            <div v-else class="contact-info__header">Current Policy</div>
            <div v-for="[accountName, accountDetail] in accountDetails" :key="accountName" class="account-list">
                <div class="account-list__name">{{ accountName }}</div>
                <div class="account-list__policies">
                    <div v-for="(policy, policyKey) in accountDetail.policies" :key="policyKey" class="policy-list">
                        <div class="policy-list__name">{{ policy.name }}</div>
                        <ul class="policy-list__detail">
                            <li><strong>Effective:</strong> {{ policy.effectiveDate | formatDate }}</li>
                            <li><strong>Expiration:</strong> {{ policy.expirationDate | formatDate }}</li>
                            <li v-if="isCancelled(policy)"><strong>Cancellation:</strong> {{ policy.cancellationDate | formatDate }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- TODO: Restore the video to Vimeo or replace with something else; Jake Laack 2024-06-13
            <div class="Tutorial">
                <a href="#" @click="video = true">Using monthly self-reporting</a><font-awesome-icon :icon="['fas', 'video']" style="padding-left: 5px"/>
            </div>
            <div class="modal-overlay" v-if="video">
                <div class="modal">
                    <div class="modal-content" id="session-expired">
                        <div class="modal-header">
                            <h2>Using monthly self-reporting</h2>
                        </div>
                        <div class="modal-main-content">
                            <iframe src="https://player.vimeo.com/video/488213297" title="Using monthly self-reporting" width="640" height="347" allow="autoplay; fullscreen" allowfullscreen></iframe>
                        </div>
                        <div class="modal-footer">
                            <slot name="footer">
                                <button class="button-sm purple" @click="video = false">
                                    Close
                                </button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
            -->
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import mixin from "../mixins/confAndReportingMixin";

export default {
    mixins: [mixin],
    name: 'CompanyInfo',
    data() {
        return {
            video: false
        }
    },
    computed: {
        ...mapState([ 'contact', 'policies' ]),
        accountDetails: function() {
            const accountDetails = new Map();
            for (const policy of this.policies) {
                let accountName = policy.accountName
                let accountDetail = accountDetails.get(accountName)
                if (! accountDetail) {
                    accountDetails.set(accountName, { policies: [ policy ] })
                } else {
                    accountDetail.policies.push(policy)
                }
            }
            return accountDetails
        }
    },
    methods: {
        isCancelled(pol) {
            return pol.cancellationDate !== null
        }
    }
}
</script>

<style scoped>
    .modal-main-content{
        display: flex;
        align-items: center;
        padding: 5em 5em;
    }
    .modal-header h2 {
        color: white;
    }
</style>
